export default "https://cdn-static.gokick.com/assets/75ac565edfb9d82dbbe43c50f72b37b3535e18ca/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";